import {
  SnackbarMessage,
  SnackbarMessageType,
} from "@/App/Equities/shared/components"
import {
  clearEquitiesError,
  useEquitiesErrors,
} from "@/App/Equities/shared/services/errorAlert"
import { typedEntries } from "@/utils/typedEntries"

/**
 * Renders the head of the equities error queue as a single snackbar.
 * Errors from different sources coexist FIFO by first occurrence; dismiss clears
 * the head and advances to the next active error. Same-source republish dedups.
 */
export const EquitiesErrorAlert = () => {
  const rawErrors = useEquitiesErrors()
  const equitiesError = typedEntries(rawErrors ?? {})
  const activeError = equitiesError[0]

  if (!activeError) {
    return null
  }

  const [service, message] = activeError

  return (
    <SnackbarMessage
      type={SnackbarMessageType.ERROR}
      isOpen
      onClose={() => clearEquitiesError(service)}
      message={message}
      autoHideDuration={null}
    />
  )
}
